// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

function clickAwayCatcher(idx) {
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.position("fixed"),
              BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.bottom(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.right(BsCssJs$PrezzeeRibbon.zero),
              BsCssJs$PrezzeeRibbon.backgroundColor("transparent"),
              BsCssJs$PrezzeeRibbon.zIndex(idx)
            ]);
}

var Styles = {
  clickAwayCatcher: clickAwayCatcher
};

var make = React.memo(function (props) {
      var zIndex = props.zIndex;
      var zIndex$1 = zIndex !== undefined ? zIndex : -1;
      return JsxRuntime.jsx("div", {
                  "aria-hidden": true,
                  className: clickAwayCatcher(zIndex$1),
                  onClick: props.onClick
                });
    });

export {
  Styles ,
  make ,
}
/* make Not a pure module */
